import { render } from "./AppInfo.vue?vue&type=template&id=c4c3319a&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=c4c3319a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c3319a"]])

export default __exports__